const React = require('react');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const trim = require('mn-utils/trim');
const filter = require('mn-utils/filter');
const isString = require('mn-utils/isString');
const formatTime = require('mn-utils/formatTime');
const {
  CURRENCY_ITEMS,
} = require('../../../../../../constants');
const {
  COUNTRIES_UPPERCASE,
} = require('../../../../../../constants/countries');
const {
  LINK_ADMIN_PAYOUT_NIUM_REMITTERS,
} = require('../../../../../../constants/links');
const {
  replaceLocation,
  Link,
} = require('../../../../../../router');
const intHandle = require('../../../../../../utils/intHandle');
const withState = require('../../../../../../utils/withState');
const {
  apiAdminPayoutNiumRemitterGet,
  apiAdminPayoutNiumRemitterAdd,
  apiAdminPayoutNiumRemitterUpdate,
} = require('../../../../../../api/admin/payout/nium/remitter');
const {
  openV1PopupInfo,
} = require('../../../../../../emitters/popup');

const LayoutB = require('../../../../../dumb/Layout/B');
const CaptionA = require('../../../../../dumb/Caption/A');
const HeaderA = require('../../../../../dumb/Header/A');
const TextField = require('../../../../../dumb/TextField/Reg2');
const ButtonJ = require('../../../../../dumb/Button/J');
const Select = require('../../../../../dumb/Select/E');
const ButtonBack = require('../../../../../dumb/Button/Back');
const KeyboardDatePicker = require('../../../../../dumb/KeyboardDatePicker/C');
const WrapperWithLoading = require('../../../../../dumb/WrapperWithLoading');

const DEFAULT_NAME = 'Lunu UAB Europe';
const DEFAULT_IDENTIFICATION_TYPE = 'Company Registration No';
const DEFAULT_COUNTRY_CODE = 'DE';
const DEFAULT_REGION = 'Berlin';
const DEFAULT_CITY = 'Berlin';
const DEFAULT_POSTCODE = '14059';
const DEFAULT_ADDRESS = '9-10 Am bhanof westend';
const DEFAULT_CONTACT_NUMBER = '00491729868890';
const DEFAULT_PLACE_OF_BIRTH = 'DE';
const DEFAULT_BIRTHDAY = '1990-06-03';
const DEFAULT_SOURCE_OF_INCOME = 'Retailer transactions';
const DEFAULT_SOURCE_OF_FUNDS = 'Payment Gateway Retail transactions';
const DEFAULT_NATIONALITY = 'DE';
const DEFAULT_OCCUPATION = 'EXECUTIVE';


const IDENTIFICATION_TYPES = [
  'Registration ID', 'ACRA', 'Travel Agent License number',
  'Company Registration No', 'License No', 'ARNU',
  'DRLC', 'NIDN', 'CCPT',
];


module.exports = withState((setState, self, onMount) => {
  const changeProvider = changeProviderProvider(setState);
  let _id;
  let _fiat_code;
  let _cancel = noop;

  const handleChangeNiumAccountId = changeProvider('niumAccountId', 0, intHandle);
  const handleChangeName = changeProvider('name');
  const handleChangeNationality = handleProvider('nationality');
  const handleChangeBirthday = handleProvider('birthday');
  const handleChangePlaceOfBirth = handleProvider('placeOfBirth');
  const handleChangeContactNumber = changeProvider('contactNumber');
  const handleChangeOccupation = changeProvider('occupation');
  const handleChangeSourceOfIncome = changeProvider('sourceOfIncome');
  const handleChangeSourceOfFunds = changeProvider('sourceOfFunds');
  const handleChangeIdentificationType = handleProvider('identificationType');
  const handleChangeIdentificationNumber = changeProvider('identificationNumber');
  const handleChangeCountryCode = handleProvider('countryCode');
  const handleChangeRegion = changeProvider('region');
  const handleChangeCity = changeProvider('city');
  const handleChangePostcode = changeProvider('postcode');
  const handleChangeAddress = changeProvider('address');


  function handleProvider(key) {
    return (v) => {
      setState({
        [key]: v,
      });
    };
  }
  function setData(error, response) {
    response = response || {};

    setState({
      loading: false,
      error,
      fiatCode: response.fiat_code,
      niumAccountId: response.nium_account_id,
      identificationType: response.identification_type,
      identificationNumber: response.identification_number,

      countryCode: response.country_code,
      region: response.state,
      city: response.city,
      postcode: response.postcode,
      address: response.address,

      sourceOfIncome: response.source_of_income,
      sourceOfFunds: response.source_of_funds,

      birthday: response.dob ? new Date(response.dob) : undefined,
      placeOfBirth: response.place_of_birth,

      nationality: response.nationality,
      occupation: response.occupation,
    });
  }

  function update() {
    _cancel();
    _cancel = delay(() => {
      if (_id === 'add') {
        setData();
        return;
      }
      setState({
        loading: true,
      });
      _cancel = apiAdminPayoutNiumRemitterGet({
        nium_account_id: +_id,
        fiat_code: _fiat_code,
      }).finally(setData).cancel;
    });
  }

  onMount(() => {
    return () => {
      _cancel();
    };
  });

  return (state, props) => {
    const params = props.params || {};
    const {
      id,
      fiat_code,
    } = params;

    _id === id || update(_id = id, _fiat_code = fiat_code);


    const clicked = state.clicked || false;

    const fiatCode = state.fiatCode;
    const invalidFiatCode = !fiatCode;

    let name = state.name;
    name === undefined && (name = DEFAULT_NAME);
    const _name = trim(name);
    const invalidName = !_name;

    const niumAccountId = state.niumAccountId || '';
    const _niumAccountId = trim(String(niumAccountId));
    const invalidNiumAccountIdLength = _niumAccountId.length > 20;
    const invalidNiumAccountId = !_niumAccountId
      || invalidNiumAccountIdLength;


    let identificationType = state.identificationType;
    identificationType === undefined && (identificationType = DEFAULT_IDENTIFICATION_TYPE);
    const invalidIdentificationType = !identificationType;

    const identificationNumber = state.identificationNumber || '';
    const _identificationNumber = trim(identificationNumber);
    const invalidIdentificationNumberLength = _identificationNumber.length > 20;
    const invalidIdentificationNumber = !_identificationNumber
      || invalidIdentificationNumberLength;

    let countryCode = state.countryCode;
    countryCode === undefined && (countryCode = DEFAULT_COUNTRY_CODE);
    const invalidCountryCode = !countryCode;

    let region = state.region;
    region === undefined && (region = DEFAULT_REGION);
    const _region = trim(region);
    const invalidRegion = !_region;

    let city = state.city;
    city === undefined && (city = DEFAULT_CITY);
    const _city = trim(city);
    const invalidCity = !_city;

    let address = state.address;
    address === undefined && (address = DEFAULT_ADDRESS);
    const _address = trim(address);
    const invalidAddress = !_address;

    let postcode = state.postcode;
    postcode === undefined && (postcode = DEFAULT_POSTCODE);
    const _postcode = trim(postcode);
    const invalidPostcode = !_postcode;

    let contactNumber = state.contactNumber;
    contactNumber === undefined && (contactNumber = DEFAULT_CONTACT_NUMBER);
    const _contactNumber = trim(contactNumber);
    const invalidContractNumber = !_contactNumber;

    let sourceOfIncome = state.sourceOfIncome;
    sourceOfIncome === undefined && (sourceOfIncome = DEFAULT_SOURCE_OF_INCOME);
    const _sourceOfIncome = trim(sourceOfIncome);
    const invalidSourceOfIncome = !_sourceOfIncome;

    let sourceOfFunds = state.sourceOfFunds;
    sourceOfFunds === undefined && (sourceOfFunds = DEFAULT_SOURCE_OF_FUNDS);
    const _sourceOfFunds = trim(sourceOfFunds);
    const invalidSourceOfFunds = !_sourceOfFunds;

    let birthday = state.birthday;
    birthday === undefined && (birthday = DEFAULT_BIRTHDAY);
    const invalidBirthday = !birthday;

    let placeOfBirth = state.placeOfBirth;
    placeOfBirth === undefined && (placeOfBirth = DEFAULT_PLACE_OF_BIRTH);
    const invalidPlaceOfBirth = !placeOfBirth;

    let nationality = state.nationality;
    nationality === undefined && (nationality = DEFAULT_NATIONALITY);
    const invalidNationality = !nationality;

    let occupation = state.occupation;
    occupation === undefined && (occupation = DEFAULT_OCCUPATION);
    const _occupation = trim(occupation);
    const invalidOccupation = !_occupation;


    const disabled = invalidFiatCode
      || invalidName
      || invalidNiumAccountId
      || invalidIdentificationType
      || invalidIdentificationNumber
      || invalidCountryCode
      || invalidRegion
      || invalidCity
      || invalidAddress
      || invalidPostcode
      || invalidContractNumber
      || invalidSourceOfIncome
      || invalidSourceOfFunds
      || invalidBirthday
      || invalidPlaceOfBirth
      || invalidNationality
      || invalidOccupation;


    return (
      <LayoutB>
        <HeaderA>
          <CaptionA
            className="fx1 wmin0"
            description={id}
          >
            {id === 'add' ? 'Add Nium Remitter' : 'Change Nium Remitter'}
          </CaptionA>
          <ButtonBack
            component={Link}
            href={LINK_ADMIN_PAYOUT_NIUM_REMITTERS}
          />
        </HeaderA>
        <WrapperWithLoading
          className="mt30"
          loading={state.loading}
        >
          <div className="mh-10 layoutRow fhaS fvaC (ph10|fx1)>1">
            <div className="wmax150">
              <Select
                className="w"
                placeholder="Fiat code *"
                propName={({
                  id,
                  name,
                  main,
                }) => !main && name ? `${id} - ${name}` : id}
                propValue="id"
                error={clicked && invalidFiatCode}
                displayEmpty
                items={CURRENCY_ITEMS}
                value={fiatCode}
                onChange={(fiatCode) => {
                  setState({
                    fiatCode,
                  });
                }}
              />
            </div>
            <TextField
              label="Nium account id *"
              value={niumAccountId}
              error={clicked && invalidNiumAccountId}
              onChange={handleChangeNiumAccountId}
            />
          </div>

          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <TextField
              label="Name *"
              value={name}
              error={clicked && invalidName}
              onChange={handleChangeName}
            />
            <div>
              <Select
                className="w"
                placeholder="Nationality *"
                error={clicked && invalidNationality}
                propName="0"
                propValue="1"
                displayEmpty
                items={COUNTRIES_UPPERCASE}
                value={nationality}
                onChange={handleChangeNationality}
              />
            </div>
          </div>

          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <div>
              <KeyboardDatePicker
                label="Date of birth"
                value={birthday}
                onChange={handleChangeBirthday}
              />
            </div>
            <div>
              <Select
                className="w"
                placeholder="Place of birth *"
                error={clicked && invalidPlaceOfBirth}
                propName="0"
                propValue="1"
                displayEmpty
                items={COUNTRIES_UPPERCASE}
                value={placeOfBirth}
                onChange={handleChangePlaceOfBirth}
              />
            </div>
          </div>

          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <TextField
              className="fx1"
              label="Contact number *"
              value={contactNumber}
              error={clicked && invalidContractNumber}
              onChange={handleChangeContactNumber}
            />
            <TextField
              className="fx1"
              label="Occupation *"
              value={occupation}
              error={clicked && invalidOccupation}
              onChange={handleChangeOccupation}
            />
          </div>

          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <TextField
              label="Source of income *"
              value={sourceOfIncome}
              error={clicked && invalidSourceOfIncome}
              onChange={handleChangeSourceOfIncome}
            />
            <TextField
              label="Source of funds *"
              value={sourceOfFunds}
              error={clicked && invalidSourceOfFunds}
              onChange={handleChangeSourceOfFunds}
            />
          </div>

          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <div>
              <Select
                className="w"
                placeholder="Identification type *"
                error={clicked && invalidIdentificationType}
                displayEmpty
                items={IDENTIFICATION_TYPES}
                value={identificationType}
                onChange={handleChangeIdentificationType}
              />
            </div>
            <TextField
              label="Identification number *"
              value={identificationNumber}
              error={clicked && invalidIdentificationNumber}
              onChange={handleChangeIdentificationNumber}
              helperText={invalidIdentificationNumberLength
                && 'The length must be no more than 20 characters'}
            />
          </div>

          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <div>
              <Select
                className="w"
                placeholder="Country *"
                error={clicked && invalidCountryCode}
                propName="0"
                propValue="1"
                displayEmpty
                items={COUNTRIES_UPPERCASE}
                value={countryCode}
                onChange={handleChangeCountryCode}
              />
            </div>
            <TextField
              label="State *"
              value={region}
              error={clicked && invalidRegion}
              onChange={handleChangeRegion}
            />
          </div>
          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <TextField
              label="City *"
              value={city}
              error={clicked && invalidCity}
              onChange={handleChangeCity}
            />
            <TextField
              label="Postcode *"
              value={postcode}
              error={clicked && invalidPostcode}
              onChange={handleChangePostcode}
            />
          </div>
          <TextField
            className="mt20"
            label="Address *"
            value={address}
            error={clicked && invalidAddress}
            onChange={handleChangeAddress}
          />
          <div className="pt90 layoutRow fhaB fvaC">
            <ButtonJ
              disabled={clicked && disabled}
              onClick={() => {
                if (disabled) {
                  setState({
                    clicked: true,
                  });
                  return;
                }
                setState({
                  loading: true,
                });


                (
                  id === 'add'
                    ? apiAdminPayoutNiumRemitterAdd
                    : apiAdminPayoutNiumRemitterUpdate
                )(filter({
                  id,
                  fiat_code: fiatCode,
                  name: _name,
                  nium_account_id: parseInt(_niumAccountId),
                  contact_number: _contactNumber,

                  identification_type: identificationType,
                  identification_number: _identificationNumber,

                  country_code: countryCode,
                  state: _region,
                  city: _city,
                  postcode: _postcode,
                  address: _address,

                  source_of_income: _sourceOfIncome,
                  source_of_funds: _sourceOfFunds,

                  dob: isString(birthday)
                    ? birthday
                    : (
                      birthday && !isNaN(birthday)
                        ? formatTime(birthday, '{yyyy}-{mm}-{dd}')
                        : ''
                    ),
                  place_of_birth: placeOfBirth,

                  nationality: nationality,
                  occupation: _occupation,
                })).finally((error) => {
                  setState({
                    loading: false,
                  });
                  error || (
                    replaceLocation({
                      path: LINK_ADMIN_PAYOUT_NIUM_REMITTERS,
                    }),
                    openV1PopupInfo([
                      'Nium Remitter',
                      'Settings have been updated',
                    ])
                  );
                });
              }}
            >Save</ButtonJ>
          </div>
        </WrapperWithLoading>
      </LayoutB>
    );
  };
}, {});
